module.exports = __webpack_public_path__ + "img/kate_macK211177.db12cda5.jpg";